import * as Input from './Input.css';

export default {
	Input
};
